import './index.css';
import 'ts-polyfill/lib/es2019-array';
import * as ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();